import type { ReactNode } from 'react';
import { DsProvider } from '@workpay/ds-shared/context/DsProvider';
import { signingService } from '@services/signingService';
import { reviewService } from '@services/reviewService';
import { fileService } from '@services/fileService';
import { editorService } from '@services/editorService';

const services = {
  signing: signingService,
  reviewPublic: reviewService,
  file: fileService,
  editor: editorService,
};

export function DsExternalProvider({ children }: { children: ReactNode }) {
  return (
    <DsProvider
      services={services}
      // No translate — use English fallbacks
      // No notify — swallow notifications
      // No hasPermission — external = no permissions
      onlyOfficeUrl={import.meta.env.VITE_ONLYOFFICE_URL || 'http://localhost:8088'}
    >
      {children}
    </DsProvider>
  );
}
